// =================
// == ANIMATOR.JS ==
// =================
/*
  Rather than scattering our components with animations
  which more or less will contain the same or similar rules
  (for app-wide consistency), all animations should live in
  this file and be exported.
*/

import anime from 'animejs';

export default class Animator {
  constructor() {
    // Reusable units
    this.settings = {
      delay: 150,
    };

    this.partials = {
      emptyStart: { value: 0, duration: 0 },
    };

    // Full animations
    this.animations = {
      fadeIn: {
        opacity: [this.partials.emptyStart, { value: 1, duration: 1000 }],
        easing: 'easeInQuart',
        offset: '-=1250',
      },
      downAndFadeOut: {
        fadeOut: {
          opacity: [
            this.partials.emptyStart,
            { delay: this.settings.delay, value: 1, duration: 600 },
          ],
        },
        slideDown: {
          translateY: [
            { value: 25, duration: 0 },
            { delay: this.settings.delay, value: 0, duration: 400 },
          ],
        },
        easing: 'easeInOutExpo',
      },
      downAndOut: {
        translateY: 50,
        duration: 200,
        easing: 'easeInOutQuad',
        opacity: 0,
      },
    };

    // Timeline
    this._setupTimeline();
  }

  _setupTimeline() {
    this.timeline = anime.timeline();
    this.finished = this.timeline.finished;
  }

  call(target, ...args) {
    if (typeof args !== 'object') {
      return console.error('Invalid args passed into Animator.fadeIn');
    }
    const config = Object.assign(
      {
        targets: target,
      },
      ...args,
    );
    anime(config);
    return this;
  }

  fadeIn(target, ...args) {
    if (typeof args !== 'object') {
      return console.error('Invalid args passed into Animator.fadeIn');
    }
    const config = Object.assign(
      {
        targets: target,
        ...this.animations.fadeIn,
      },
      ...args,
    );
    this.timeline.add(config);
    // make chainable
    return this;
  }
}
